import type { Catalog } from "./catalog.js";

// German (Germany). Emergency register, plain Hochdeutsch.
// Full coverage of en.ts (enforced by test/i18n-coverage.test.ts).
export const de: Catalog = {
  "app.name": "Beacon",
  // Onboarding — Versprechen
  "onboarding.promise.tagline": "Nachbarn warnen Nachbarn.",
  "onboarding.promise.proof.corroboration": "×14 mediane Bestätigungen pro Meldung",
  "onboarding.promise.proof.time": "unter 90 s bis zur bestätigten Meldung",
  "onboarding.promise.proof.nosignup": "0 Konten, Telefonnummern oder Anmeldungen erforderlich",
  "onboarding.promise.continue": "Loslegen",
  "onboarding.promise.restore": "Meine Identität wiederherstellen",
  "onboarding.promise.step": "WILLKOMMEN",
  // Onboarding — Berechtigungen (JIT-honest)
  "onboarding.perms.step": "SCHRITT 2 / 3",
  "onboarding.perms.title": "So fragt Beacon nach Berechtigungen",
  "onboarding.perms.location": "Der Standort dient nur zur Überwachung deiner Gegend. Wir fragen beim ersten Zentrieren der Karte.",
  "onboarding.perms.notifications": "Benachrichtigungen enthalten Warnungen. Wir fragen beim ersten Aktivieren.",
  "onboarding.perms.background": "Hintergrundaktualisierung hält Warnungen aktuell. Optional, wird im Kontext gefragt.",
  "onboarding.perms.later": "Später einrichten",
  "onboarding.perms.continue": "Weiter",
  // Onboarding — Heimatbereich
  "onboarding.home.step": "SCHRITT 3 / 3",
  "onboarding.home.title": "Wo ist dein Zuhause?",
  "onboarding.home.radius": "Überwachungsradius",
  "onboarding.home.km": "{n} km",
  "onboarding.home.pickHint": "Verschiebe die Karte, bis die Nadel diesen Ort markiert.",
  "onboarding.home.confirm": "Diesen Bereich überwachen",
  "onboarding.home.browse": "Vorerst nur erkunden",
  "onboarding.home.locating": "Standort wird ermittelt…",
  "onboarding.home.located": "Stecknadel auf deinem aktuellen Standort — bei Bedarf anpassen.",
  "onboarding.home.unavailable": "Standort nicht verfügbar — verschiebe die Karte zu deinem Zuhause.",
  // Jetzt-Tab — Status
  "now.meta": "{place} · {radius} km",
  "now.meta.ago": "vor {m} min",
  "now.meta.justNow": "gerade eben",
  "now.meta.none": "noch keine Ereignisse",
  "now.meta.net": "Netz {v}",
  "now.meta.netDown": "Netz —",
  "now.meta.info.title": "Was diese Zahlen bedeuten",
  "now.meta.info.radius": "{radius} km — der Beobachtungsradius deines Heimbereichs.",
  "now.meta.info.area": "{area} — wann das letzte Ereignis für deinen Heimbereich eintraf (Vorfall, Ausbreitung, Wetter oder Hilfe).",
  "now.meta.info.net": "Netz {net} — wann das letzte Ereignis netzweit eingegangen ist, aus irgendeiner Quelle oder von Nachbarn in ganz Europa. Bewegt sich das und deins nicht, ist das Netz in Ordnung und hat nur nichts Neues für dich.",
  "now.meta.info.feeds": "Quellen hinter dem, was du siehst: {feeds}.",
  "now.place.default": "deine Gegend",
  "region.unsupported.title": "Außerhalb der kartierten Region",
  "region.unsupported.body": "Für diesen Standort sind noch keine Kartenkacheln verfügbar.",
  "now.status.step": "JETZT",
  "now.status.allClear": "Alles ruhig.",
  "now.status.stayAware": "Aufmerksam bleiben.",
  "now.status.nearby.fire": "Feuer in der Nähe.",
  "now.status.nearby.flood": "Hochwasser in der Nähe.",
  "now.status.nearby.earthquake": "Erdbeben gespürt.",
  "now.status.nearby.conflict": "Konflikt in der Nähe.",
  "now.status.nearby.other": "Gefahr in der Nähe.",
  "now.status.nearby.traffic": "Verkehrsbehinderung in der Nähe.",
  "now.status.nearby.storm": "Sturm in der Nähe.",
  "now.status.nearby.snow": "Schnee in der Nähe.",
  "now.status.nearby.ice": "Glatteis auf Straßen in der Nähe.",
  "now.status.nearby.heat": "Extreme Hitzewarnung.",
  "now.status.nearby.fog": "Dichter Nebel in der Nähe.",
  "now.status.nearby.hazmat": "Gefahrstoffalarm in der Nähe.",
  "now.status.nearby.outage": "Versorgungsausfall in der Nähe.",
  "now.status.sub": "{distance} km · {place}",
  "now.status.sub.allClear": "Nichts Aktives innerhalb deines Überwachungsradius.",
  // Jetzt-Tab — Gemeinschaftsstreifen
  "now.community.neighbors": "{n} Nachbarn",
  "now.community.watching": "BEOBACHTEN",
  "now.community.helpers": "{n} Helfer",
  "now.community.helpersLabel": "IN DER NÄHE",
  "now.community.median": "<90s",
  "now.community.medianLabel": "BIS ZUR BESTÄTIGTEN MELDUNG",
  "now.community.corroborated": "×{n}",
  "now.community.corroboratedLabel": "BESTÄTIGT",
  // Jetzt-Tab — Aktivität + Meldung
  "now.activity.title": "IN DER NÄHE",
  "now.activity.empty": "Gerade nichts in der Nähe.",
  "now.pulse.live": "Netz aktiv — letztes Ereignis vor {s} s",
  "now.pulse.quiet": "Netz seit {m} min ruhig",
  "now.pulse.unreachable": "Relay nicht erreichbar",
  "now.pulse.area": "Dein Bereich: letzte Meldung vor {m} min",
  "now.pulse.areaNone": "Dein Bereich: noch keine Meldungen",
  "now.zone.addHere": "Du bist außerhalb deiner beobachteten Orte — hier als Zone hinzufügen?",
  "now.activity.corroboration": "BESTÄTIGT ×{n}",
  "now.group.areas": "{n} Gebiete",
  "now.group.expand": "Gebiete anzeigen",
  "now.report.button": "Melden",
  "now.recenter": "Auf mich zentrieren",
  "now.fitAll": "Alle Orte anzeigen",
  "now.raw.toggle": "Rohmeldungen",
  "now.raw.list.title": "Meldungen ({n})",
  "now.raw.list.more": "+{n} weitere",
  "now.raw.detail": "{hazard} · über {feed} · {time}",
  "now.report.title": "Meldung",
  "now.report.unverified": "Unbestätigte Meldung — noch nicht bestätigt",
  "now.report.event": "Ereignis",
  "now.report.response": "Reaktion",
  "now.report.severity": "Schwere",
  "now.report.observed": "Beobachtet",
  "now.report.source": "Quelle",
  "now.warning.viewSource": "Vollständige Warnung anzeigen ↗",
  // Meldeformular — Bestätigungsmodus
  "report.corroborate.title": "Bestätigen",
  "report.corroborate.q": "Ist das der {hazard} bei {place}?",
  "report.corroborate.yes": "Ja, ich sehe es auch",
  "report.corroborate.no": "Nein, das ist etwas anderes",
  // Meldeformular — vollständiger Ablauf
  "report.title": "Gefahr melden",
  "report.step.what": "Was passiert?",
  "report.step.where": "Wo?",
  "report.step.howbad": "Wie schlimm?",
  "report.where.here": "Hier (meine Gegend)",
  "report.where.honesty": "Wird als dein Viertel geteilt, nicht als deine Adresse.",
  "report.where.pick": "Punkt auf der Karte wählen",
  "report.where.pickHint": "Schiebe die Karte, bis die Nadel auf dem Ort sitzt.",
  "report.where.current": "Aktueller Standort",
  "report.where.home": "Zuhause",
  "report.where.pin": "Nadel auf der Karte",
  "report.where.selected": "Meldung bei",
  "report.where.locating": "Standort wird ermittelt…",
  "report.where.locateFailed": "Standort konnte nicht ermittelt werden — Meldung vom Heimatort.",
  "report.note.placeholder": "Eine Zeile hinzufügen (optional)",
  "report.next": "Weiter",
  "report.back": "Zurück",
  "report.submit": "Meldung senden",
  "report.cancel": "Abbrechen",
  "report.severity.label": "Schweregrad",
  // Meldeformular — Bestätigung
  "report.done.title": "Gesendet",
  "report.done.body": "Jetzt für Nachbarn sichtbar. Warnungen werden ausgelöst, wenn andere bestätigen.",
  "report.done.close": "Fertig",
  "report.error": "Senden fehlgeschlagen — du kannst es erneut versuchen.",
  // Gefahren (kontrolliertes Vokabular)
  "hazard.fire": "Feuer",
  "hazard.flood": "Hochwasser",
  "hazard.earthquake": "Erdbeben",
  "hazard.conflict": "Konflikt",
  "hazard.other": "Gefahr",
  "hazard.traffic": "Verkehr", "hazard.storm": "Sturm", "hazard.snow": "Schnee",
  "hazard.ice": "Glatteis", "hazard.heat": "Hitze", "hazard.fog": "Nebel",
  "hazard.hazmat": "Gefahrstoffe", "hazard.outage": "Versorgungsausfall",
  // Navigation
  "tab.now": "Jetzt",
  "tab.help": "Hilfe",
  "tab.you": "Du",
  "tab.talk": "Reden",
  "tab.beacon": "Beacon-Einstellungen",
  "beacon.tab.step": "EINSTELLUNGEN",
  "beacon.tab.title": "Beacon",
  // Reden-Tab
  "talk.scope.area": "Meine Gegend",
  "talk.scope.region": "Weitere Region",
  "talk.region.size": "Regionsgröße: ~{km} km",
  "talk.band.area": "in deiner Gegend",
  "talk.band.region": "deine Region · ~{km} km",
  "talk.band.distant": "entfernt",
  "talk.you": "Du",
  "talk.empty": "Noch keine Nachrichten. Grüß deine Nachbarn.",
  "zone.checking": "Bereich wird geprüft…",
  "zone.stalled": "Netzwerk noch nicht erreichbar — wird weiter versucht…",
  "zone.progress.windows": "Verlauf {done}/{total}",
  "zone.progress.attempts": "Versuch {done}/{total}",
  "zone.retry": "Erneut versuchen",
  "talk.placeholder.locked": "🔒 Nachricht nicht verfügbar",
  "talk.composer.placeholder": "Schreib deiner Gegend…",
  "talk.composer.send": "Senden",
  "talk.new.count": "{n} neu ↓",
  "talk.zone.home": "Home",
  "talk.zone.nearby": "Nearby",
  "talk.compose.noCell": "Waiting for this place's location…",
  "banner.simulation": "SIMULATION",
  "locale.switch": "Sprache",
  // Warnungseingang — Toast/Übernahme (C4)
  "alert.toast.new": "{hazard} in der Nähe gemeldet",
  "alert.toast.escalation": "{hazard} in der Nähe hat sich verschlimmert",
  "alert.toast.inPath": "{hazard} bewegt sich auf dich zu",
  "alert.toast.reAlert": "{hazard} in der Nähe — Aktualisierung",
  "alert.toast.allClear": "Alles ruhig bei {place}",
  "alert.toast.sub": "{distance} km · {place}",
  "alert.toast.tap": "Tippe für Details und Sicherheitshinweise",
  "alert.toast.more": "+{n} weitere",
  "alert.severity.info": "HINWEIS",
  "alert.severity.warning": "WARNUNG",
  "alert.severity.critical": "KRITISCH",
  "alert.takeover.title": "{hazard} — jetzt handeln",
  "alert.takeover.sub": "{distance} km von {place}",
  "alert.takeover.steps": "SICHERHEITSHINWEISE",
  "alert.takeover.details": "Alle Details anzeigen",
  "alert.takeover.dismiss": "Schließen",
  "alert.takeover.dismissNext": "Schließen & nächste ansehen · {n} weitere",
  // Vorfalldetail (C4)
  "incident.detail.metrics.corroborated": "×{n}",
  "incident.detail.reports.title": "Meldungen dahinter ({n})",
  "incident.detail.metrics.corroboratedLabel": "BESTÄTIGT",
  "incident.detail.metrics.first": "{ago}",
  "incident.detail.metrics.firstLabel": "ERSTE MELDUNG",
  "incident.detail.metrics.spread": "{status}",
  "incident.detail.metrics.spreadLabel": "AUSBREITUNG",
  "incident.detail.spread.moving": "Bewegt sich ~{speed} km/h",
  "incident.detail.spread.stationary": "Ortsfest",
  "incident.detail.spread.dissipating": "Nachlassend",
  "incident.detail.spread.unknown": "—",
  "incident.detail.steps": "SICHERHEITSHINWEISE",
  "incident.detail.directions": "Route",
  "incident.detail.share": "Teilen",
  "incident.detail.help": "Ich kann helfen",
  "incident.detail.helpSoon": "Hilfekoordination folgt bald.",
  "incident.detail.flag": "Problem mit dieser Warnung melden",
  "incident.detail.flagSoon": "Markierung folgt bald.",
  "incident.detail.back": "Zurück",
  "incident.detail.away": "{hazard} — {n} km entfernt",
  "incident.detail.ago.min": "vor {n} Min.",
  "incident.detail.ago.hr": "vor {n} Std.",
  "incident.detail.ago.now": "gerade eben",
  // Vorfalldetail — Detailblock (Ursprung / Schwere / Status) + Bestätigung
  "incident.detail.meta.title": "DETAILS",
  "incident.detail.meta.origin": "Ursprung",
  "incident.detail.meta.severity": "Schweregrad",
  "incident.detail.meta.status": "Status",
  "incident.detail.origin.crowd": "Gemeinschaft",
  "incident.detail.origin.authority": "Offiziell",
  "incident.severity.1": "Gering",
  "incident.severity.2": "Ernst",
  "incident.severity.3": "Schwer",
  "incident.status.open": "Aktiv",
  "incident.status.sustained": "Anhaltend",
  "incident.status.closing": "Nachlassend",
  "incident.status.closed": "Abgeschlossen",
  "incident.detail.seeIt": "Ich sehe es auch",
  "incident.detail.seeItDone": "Danke — deine Meldung wurde hinzugefügt.",
  "incident.detail.tab.safety": "Sicherheit",
  "incident.detail.tab.details": "Details",
  "incident.detail.tab.actions": "Aktionen",
  "incident.detail.helpBrowse": "Hilfeanfragen durchsuchen",
  // Sicherheitshinweise — toninvariant, pro Gefahr (GUI §3)
  "safety.fire.1": "Frühzeitig weg — warte nicht, bis du Flammen siehst.",
  "safety.fire.2": "Geh in den Wind und hangaufwärts weg vom Rauch.",
  "safety.fire.3": "Nimm Wasser, Medikamente und dein Telefon mit.",
  "safety.fire.4": "Falls eingeschlossen: suche freies Gelände oder ein Gebäude auf.",
  "safety.flood.1": "Begib dich jetzt auf höheres Gelände.",
  "safety.flood.2": "Laufe oder fahre niemals durch fließendes Wasser.",
  "safety.flood.3": "Schalte den Strom ab, wenn Wasser drinnen steigt.",
  "safety.flood.4": "Halte dich fern von Flüssen, Abflüssen und Brücken.",
  "safety.earthquake.1": "Hinlegen, Deckung suchen und festhalten, bis das Zittern aufhört.",
  "safety.earthquake.2": "Bleib weg von Fenstern und schweren Möbeln.",
  "safety.earthquake.3": "Nach dem Beben: auf Gaslecks und Schäden prüfen.",
  "safety.earthquake.4": "Rechne mit Nachbeben — bleib bereit, erneut Deckung zu suchen.",
  "safety.conflict.1": "Entferne dich von der Gefahr und suche Deckung.",
  "safety.conflict.2": "Bleib niedrig und halte solide Wände zwischen dir und der Gefahr.",
  "safety.conflict.3": "Teile deinen Status mit jemandem, dem du vertraust.",
  "safety.conflict.4": "Befolge die örtlichen Notfallanweisungen.",
  "safety.other.1": "Entferne dich von der unmittelbaren Gefahr.",
  "safety.other.2": "Warne Nachbarn, die es vielleicht noch nicht gesehen haben.",
  "safety.other.3": "Befolge die örtlichen Notfallanweisungen.",
  "safety.traffic.1": "Langsamer fahren und mehr Abstand halten.",
  "safety.traffic.2": "Schilder beachten und früh einordnen.",
  "safety.traffic.3": "Erwäge eine alternative Route.",
  "safety.storm.1": "Drinnen bleiben und von Fenstern fernhalten.",
  "safety.storm.2": "Nicht reisen, bis der Sturm vorbei ist.",
  "safety.storm.3": "Lose Gegenstände draußen sichern.",
  "safety.storm.4": "Abstand von Bäumen und Stromleitungen halten.",
  "safety.snow.1": "Nicht notwendige Fahrten vermeiden.",
  "safety.snow.2": "Warm anziehen und Akku des Telefons laden.",
  "safety.snow.3": "Ausgänge freihalten und nach Nachbarn sehen.",
  "safety.ice.1": "Auf Straßen und Wegen vorsichtig sein.",
  "safety.ice.2": "Langsamer fahren und sanft bremsen.",
  "safety.ice.3": "Schuhe mit Grip tragen.",
  "safety.heat.1": "Oft Wasser trinken.",
  "safety.heat.2": "Im Schatten oder in kühlen Räumen bleiben.",
  "safety.heat.3": "Anstrengung mittags vermeiden.",
  "safety.heat.4": "Nach älteren und gefährdeten Personen schauen.",
  "safety.fog.1": "Tempo reduzieren und Abblendlicht einschalten.",
  "safety.fog.2": "Mehr Abstand halten.",
  "safety.fog.3": "Keine Überholmanöver.",
  "safety.hazmat.1": "Ins Gebäude und Fenster und Lüftungen schließen.",
  "safety.hazmat.2": "Das betroffene Gebiet meiden.",
  "safety.hazmat.3": "Offizielle Anweisungen befolgen.",
  "safety.outage.1": "Akku des Telefons schonen.",
  "safety.outage.2": "Taschenlampen benutzen, keine Kerzen.",
  "safety.outage.3": "Nach Nachbarn sehen, die Hilfe brauchen könnten.",
  "offline.strip": "OFFLINE · LETZTE SYNCHRONISIERUNG {time}",
  // Hilfe-Tab — Bedarfstypen (kontrolliertes Vokabular)
  "need.medical": "Medizinisch",
  "need.rescue": "Rettung",
  "need.transport": "Transport",
  "need.shelter": "Unterkunft",
  "need.supplies": "Versorgung",
  "need.hands": "Hände",
  "need.other": "Sonstiges",
  // Hilfe-Tab — Statusblock (GUI §4)
  "help.status.step": "HILFE",
  "help.status.some": "{n} Personen brauchen Hilfe in der Nähe.",
  "help.status.one": "1 Person braucht Hilfe in der Nähe.",
  "help.status.none": "Keine offenen Anfragen in der Nähe.",
  "help.status.sub": "Nächste: {need} · {distance} km",
  "help.status.subNone": "Hier siehst du offene Anfragen in deiner Gegend.",
  // Helfer-Modus-Karte
  "help.helper.toggle": "Ich kann helfen",
  "help.helper.intro": "Biete an, Nachbarn in deiner Nähe zu helfen.",
  "help.helper.tagsLabel": "Wobei kannst du helfen?",
  "help.helper.ttlLabel": "Wie lange?",
  "help.helper.ttl.today": "Heute",
  "help.helper.ttl.week": "Diese Woche",
  "help.helper.ttl.incident": "Während dieses Vorfalls",
  "help.helper.area": "Nur deine Gegend — grober Standort, nie deine Adresse.",
  "help.helper.register": "Verfügbarkeit eintragen",
  "help.helper.registered": "Du bist bereit zu helfen. Wir zeigen dir nahe Anfragen.",
  "help.helper.tierUnknown": "VERTRAUEN · wächst, wenn du hilfst und gebürgt wirst",
  // Anfragen in deiner Nähe (Matcher A7 Push, private SSE)
  "help.nearby.title": "Anfragen in deiner Nähe",
  "help.nearby.toast": "Jemand in der Nähe braucht {need}",
  "help.nearby.empty": "Noch keine Treffer — du wirst benachrichtigt.",
  "help.offer.toast": "Jemand hat Hilfe angeboten",
  "help.accept.error": "Annahme noch nicht möglich — diese Person wird noch synchronisiert. Versuch es gleich noch einmal.",
  // Offene Anfragen-Liste
  "help.list.title": "OFFENE ANFRAGEN",
  "help.list.empty": "Keine offenen Anfragen in deiner Gegend.",
  "help.list.verified": "◆",
  // Anfragendetail + Angebot/Annahme (GUI §4)
  "help.detail.back": "Zurück",
  "help.detail.needLabel": "Braucht {need}",
  "help.detail.urgencyLabel": "DRINGLICHKEIT",
  "help.detail.location": "Nur ungefähre Gegend",
  "help.detail.honesty": "Die genaue Adresse wird nur geteilt, wenn sie dein Angebot annehmen.",
  "help.detail.offer": "Hilfe anbieten",
  "help.detail.submitOffer": "Angebot senden",
  "help.detail.notePlaceholder": "Notiz hinzufügen (optional)",
  "help.detail.etaPlaceholder": "ETA in Minuten (optional)",
  "help.detail.offersTitle": "ANGEBOTE",
  "help.detail.offersEmpty": "Noch keine Angebote. Nachbarn sehen diese Anfrage.",
  "help.detail.accept": "Annehmen",
  "help.detail.accepted": "Angenommen",
  "help.detail.acceptCaveat": "Mit dem Annehmen teilst du deinen genauen Standort mit dieser Person – ihre Identität ist nicht geprüft, und es lässt sich nicht rückgängig machen.",
  "help.detail.offerSent": "Angebot gesendet. Du wirst benachrichtigt, wenn es angenommen wird.",
  // Anfrage erstellen
  "help.create.button": "Hilfe anfragen",
  "help.create.title": "Hilfe anfragen",
  "help.create.step.need": "Was brauchst du?",
  "help.create.step.what": "Was wird gebraucht?",
  "help.create.step.urgency": "Wie dringend?",
  "help.create.headlinePlaceholder": "Eine Zeile — was brauchst du?",
  "help.create.peoplePlaceholder": "Wie viele Personen?",
  "help.create.urgencyLabel": "DRINGLICHKEIT",
  "help.create.next": "Weiter",
  "help.create.back": "Zurück",
  "help.create.submit": "Anfrage einstellen",
  "help.create.error": "Konnte nicht eingestellt werden. Bitte erneut versuchen.",
  "help.create.done.title": "Anfrage eingestellt.",
  "help.create.done.body": "Nahegelegene Nachbarn können sie jetzt sehen und Hilfe anbieten.",
  "help.create.done.close": "Fertig",
  // Meine Aktivität
  "help.activity.title": "DEINE AKTIVITÄT",
  "help.activity.mine": "Deine Anfrage",
  "help.activity.helping": "Du hilfst",
  "help.activity.offered": "Du hast Hilfe angeboten",
  "help.activity.pending": "Noch nicht im Netz",
  "help.screen.resolvedDone": "Erledigt — als fertig markiert.",
  "help.screen.resolvedCancelled": "Diese Anfrage wurde abgebrochen.",
  "help.screen.loading": "Anfrage wird geladen…",
  "help.activity.activeTitle": "AKTIV",
  "help.activity.resolvedTitle": "ERLEDIGT",
  "help.activity.badge.done": "Fertig",
  "help.activity.badge.cancelled": "Abgebrochen",
  "help.activity.badge.active": "Aktiv",
  // Koordinationsthread (GUI §4, §6)
  "help.thread.back": "Zurück",
  "help.thread.title": "Koordination",
  "help.thread.precise": "Geteilter Standort",
  "help.thread.preciseSelf": "Dein geteilter Standort",
  "help.thread.heartbeat": "{name} · {state}",
  "help.thread.composePlaceholder": "Nachricht…",
  "help.thread.send": "Senden",
  "help.thread.done": "Fertig",
  "help.thread.cantMake": "Ich schaffe es nicht",
  "help.thread.you": "Du",
  "help.thread.requester": "Anfragender",
  "help.thread.helper": "Helfer · {id}",
  "help.thread.resend": "Erneut senden",
  "help.thread.empty": "Koordiniert hier. Nachrichten werden für alle in dieser Anfrage verschlüsselt.",
  "help.thread.openMap": "Karte öffnen ↗",
  "help.confirm.cancel": "Abbrechen",
  "help.confirm.done.title": "Als erledigt markieren?",
  "help.confirm.done.body": "Die helfende Person wird benachrichtigt; verschiebt nach Erledigt.",
  "help.confirm.done.confirm": "Erledigt",
  "help.confirm.cant.title": "Hilfe zurückziehen?",
  "help.confirm.cant.body": "Die Anfrage wird für andere in der Nähe wieder geöffnet.",
  "help.confirm.cant.confirm": "Zurückziehen",
  "help.status.chip.open": "Offen",
  "help.status.chip.accepted": "Angenommen",
  "help.status.chip.enroute": "Unterwegs",
  "help.status.chip.arrived": "Angekommen",
  "help.status.chip.partial": "Teilweise",
  "help.status.chip.done": "Erledigt",
  "help.status.chip.cancelled": "Abgebrochen",
  // Lebenszyklus-Schrittbezeichnungen (nummerierte Schritte)
  "help.lifecycle.open": "Offen",
  "help.lifecycle.offered": "Angeboten",
  "help.lifecycle.accepted": "Angenommen",
  "help.lifecycle.enroute": "Unterwegs",
  "help.lifecycle.arrived": "Angekommen",
  "help.lifecycle.done": "Fertig",
  // Du-Tab (GUI §5)
  "you.step": "DU",
  "you.title": "Du & deine Einstellungen",
  // Identitätskarte + Abschnitts-Schalter (von main übernommen)
  "you.card.trusted": "Vertrauenswürdiger Nachbar",
  "you.card.building": "Wird vertrauenswürdig",
  "you.card.neighbor": "Nachbar",
  "you.card.watch": "{n} km Überwachung",
  "you.card.noHome": "Kein Heimatbereich festgelegt",
  "you.card.id": "Beacon-ID",
  "you.loc.alertDetail": "Warnungen feinabstimmen",
  "you.loc.livePosition": "Live-Position",
  "you.loc.level.off": "Aus",
  "you.loc.level.info": "Info",
  "you.loc.level.warning": "Warnung",
  "you.loc.level.critical": "Kritisch",
  "you.trust.howToggle": "Wie Vertrauen funktioniert",
  "you.trust.keysToggle": "Schlüssel & Wiederherstellung",
  "you.privacy.dataToggle": "Deine Daten",
  // Standort & Warnungen
  "you.loc.title": "STANDORT & WARNUNGEN",
  "you.loc.home": "Heimatbereich",
  "you.loc.setHome": "Heimatbereich festlegen",
  "you.loc.coords": "Koordinaten",
  "you.loc.change": "Heimatbereich ändern",
  "you.loc.setHomeHint": "Wähle einen Heimatbereich, um die Karte zu sehen und Warnungen für deine Umgebung zu erhalten.",
  "you.loc.radius": "Überwachungsradius",
  "you.loc.km": "{n} km",
  "you.loc.quiet": "Ruhestunden",
  "you.loc.quietValue": "{start}:00 – {end}:00",
  "you.loc.quietOff": "Aus",
  "you.loc.quietToggle": "Nicht-kritische Warnungen nachts stummschalten",
  "you.loc.autoDismiss": "Hinweise ausblenden nach",
  "you.loc.autoDismiss.seconds": "{n}s",
  "you.loc.autoDismiss.never": "Bleibt bis zum Schließen",
  "you.loc.minsev": "Mindestschwere für Warnungen",
  "you.loc.addPlace": "Weiteren Ort hinzufügen",
  "you.loc.addCurrent": "Aktuellen Standort verwenden",
  "you.loc.liveFollow": "Meinem Standort folgen",
  "you.loc.liveFollowHint": "Warnt dich vor Gefahren an deinem aktuellen Standort, solange Beacon geöffnet ist. Verbraucht mehr Akku; standardmäßig deaktiviert.",
  "you.loc.liveFollowUnavailable": "Standortzugriff ist deaktiviert. Aktiviere ihn im Browser, um deinem Standort zu folgen.",
  "you.loc.keepAwake": "Bildschirm beim Folgen eingeschaltet lassen",
  "you.loc.keepAwakeHint": "Hält das Display beim Live-Folgen aktiv, damit keine Warnung verpasst wird. Deaktivierst du das, kann ein schlafendes Gerät nicht warnen — eine Einschränkung von Web-Apps.",
  "you.sound.title": "Warnton",
  "you.sound.hint": "Spielt bei einer Warnung einen kurzen Ton in deiner gewählten Stimme. Aus, bis du ihn einschaltest; während der Ruhezeiten immer stumm.",
  "you.sound.preview": "Beispiel abspielen",
  "you.loc.travelRadius": "Reiseradius",
  "you.loc.places": "ÜBERWACHTE ORTE",
  "you.loc.placeUnnamed": "Gespeicherter Ort",
  "you.loc.removePlace": "Entfernen",
  "now.watched.title": "Weitere überwachte Orte",
  "now.watched.alert": "Feuer bei {place}",
  "you.loc.editPlace": "Bearbeiten",
  "you.loc.placeName": "Name",
  "you.loc.homeName": "Heimatname",
  "you.loc.moveUp": "Nach oben",
  "you.loc.moveDown": "Nach unten",
  // Stimme (Unterstützer-gesperrt)
  "you.voice.title": "STIMME",
  "you.voice.intro": "Wähle, wie Beacon mit dir spricht.",
  "you.voice.official": "Offiziell",
  "you.voice.human": "Menschlich",
  "you.voice.dark": "Schwarzer Humor",
  "you.voice.deadpan": "Trocken",
  "you.voice.nonna": "Oma",
  "you.voice.preview.official": "Waldbrand gemeldet, 3 km nördlich. Von 14 Nachbarn bestätigt.",
  "you.voice.preview.human": "Nördlich von dir brennt es — deine Nachbarn sehen es auch.",
  "you.voice.preview.dark": "Feuer im Norden. Gut, dass du die Laufschuhe heute trägst.",
  "you.voice.preview.deadpan": "Feuer im Norden. Zur Kenntnis genommen.",
  "you.voice.preview.nonna": "Nördlich brennt es, Schatz — geh jetzt, ich meine das ernst.",
  // Vertrauen
  "you.trust.title": "VERTRAUEN",
  "you.trust.tier": "Deine Stufe",
  "you.trust.tierUnknown": "— vom Projektor geliefert (D2)",
  "you.trust.how": "So wächst es: Kontoalter, bestätigte Meldungen und Bürgschaften.",
  "you.trust.factor.age": "Kontoalter",
  "you.trust.factor.confirmed": "Bestätigte Meldungen",
  "you.trust.factor.vouches": "Bürgschaften",
  "you.trust.factorValue": "— vom Projektor geliefert (D2)",
  "you.trust.vouch": "Für einen Nachbarn bürgen",
  "you.trust.vouchHint": "Teile diesen Link persönlich mit jemandem, dem du vertraust.",
  "you.trust.vouchers": "Deine Bürgen",
  "you.trust.vouchersEmpty": "— vom Projektor geliefert (D2)",
  "you.trust.backup": "Schlüsselsicherung & -rotation",
  "you.trust.export": "Meine Wiederherstellungsdatei herunterladen",
  "you.trust.exportHint": "Diese Datei ist dein Konto. Bewahre sie sicher und privat auf.",
  "you.trust.import": "Aus einer Wiederherstellungsdatei wiederherstellen",
  "you.trust.rotate": "Meine Schlüssel rotieren",
  "you.trust.rotateHint": "Ersetzt deine Signierschlüssel. Danach eine neue Wiederherstellungsdatei herunterladen.",
  "you.trust.rotated": "Schlüssel rotiert. Lade jetzt deine neue Wiederherstellungsdatei herunter.",
  "you.trust.importBad": "Diese Datei ist keine gültige Beacon-Wiederherstellungsdatei.",
  "you.trust.importOk": "Wiederherstellungsdatei akzeptiert. Sie wird beim nächsten Start verwendet.",
  "you.trust.capability.direct": "Deine Meldungen warnen deine Gegend direkt.",
  "you.trust.capability.needsConfirm": "Derzeit muss ein Nachbar deine Meldung bestätigen, bevor die Gegend gewarnt wird.",
  "you.trust.capability.full": "Deine Meldungen haben bereits volles Gewicht. Größere Warnungen erfordern noch einige bestätigende Nachbarn — so bleibt Beacon vertrauenswürdig.",
  "you.trust.progress.confirmed": "Nach {confirmed} weiteren bestätigten Meldung(en) werden deine Meldungen mehr Gewicht haben.",
  "you.trust.progress.days": "Nutze Beacon noch ca. {days} Tag(e), um Ansehen aufzubauen.",
  // Datenschutz
  "you.privacy.title": "DATENSCHUTZ",
  "you.privacy.consentTitle": "Womit du einverstanden bist",
  "you.consent.alerts": "Warnungen für meine Gegend empfangen",
  "you.consent.helperAvailability": "Meine Helferverfügbarkeit teilen",
  "you.consent.preciseLocationRelease": "Genauen Standort freigeben, wenn ich eine Anfrage annehme",
  "you.consent.publicMetrics": "Zu anonymen öffentlichen Metriken beitragen",
  "you.privacy.export": "Meine Daten exportieren",
  "you.privacy.exportHint": "Eine portable Kopie aller Daten auf diesem Gerät.",
  "you.privacy.erase": "Mich löschen",
  "you.privacy.eraseHint": "Krypto-Löschung: deine Schlüssel werden vernichtet und deine Daten werden überall unzugänglich.",
  // Sicherheit & Privatsphäre — was der Hilfe-Chat schützt und wo die Grenzen liegen.
  "you.safety.title": "SICHERHEIT & PRIVATSPHÄRE",
  "you.safety.intro": "Was geschützt ist, wenn du Hilfe suchst oder anbietest – und wo die Grenzen liegen.",
  "you.safety.toggle": "Wie deine Sicherheit geschützt wird",
  "you.safety.e2ee.h": "Nachrichten sind Ende-zu-Ende-verschlüsselt",
  "you.safety.e2ee.d": "Nur du und die Person, mit der du dich abstimmst, könnt sie lesen – weder Beacon noch das Relay.",
  "you.safety.location.h": "Dein genauer Standort bleibt privat, bis du zusagst",
  "you.safety.location.d": "Helfende sehen nur dein ungefähres Gebiet. Sobald du jemanden annimmst, erhält nur diese Person deinen genauen Standort.",
  "you.safety.metadata.h": "Das Netzwerk sieht, dass du dich abstimmst",
  "you.safety.metadata.d": "Deine Worte und dein genauer Standort sind verborgen, aber dass du Hilfe bekommst, dein ungefähres Gebiet und der Zeitpunkt sind sichtbar. Behandle deine Umgebung als öffentlich.",
  "you.safety.identity.h": "Helfende werden nicht auf ihre Identität geprüft",
  "you.safety.identity.d": "Jede Person kann unter jedem Namen Hilfe anbieten. Teile sensible Angaben erst, wenn du sicher bist, mit wem du es zu tun hast.",
  "you.safety.irrevocable.h": "Das Teilen deines genauen Standorts lässt sich nicht rückgängig machen",
  "you.safety.irrevocable.d": "Sobald du zusagst, behält diese Person den geteilten Standort. Es gibt kein Zurück.",
  "you.safety.forwardSecrecy.h": "Alte Nachrichten hängen von der Sicherheit deines Geräts ab",
  "you.safety.forwardSecrecy.d": "Beacon nutzt noch nicht für jede Nachricht einen neuen Schlüssel, daher könnte ein gestohlener Schlüssel frühere Chats offenlegen. Halte dein Telefon gesperrt.",
  "you.safety.retention.h": "Nachrichten verfallen, aber du kannst sie nicht löschen",
  "you.safety.retention.d": "Abstimmungs-Nachrichten verschwinden nach einer Weile von selbst. Ein manuelles Löschen einzelner Nachrichten gibt es noch nicht.",
  // Löschbestätigung (schwerwiegend)
  "you.erase.title": "Dich aus Beacon löschen?",
  "you.erase.body": "Dadurch werden die Schlüssel vernichtet, die alles, was du geteilt hast, entsperren. Meldungen und Nachrichten, die bereits auf den Telefonen von Nachbarn sind, können nicht zurückgerufen werden, aber alles andere wird dauerhaft unzugänglich. Dies kann nicht rückgängig gemacht werden.",
  "you.erase.confirmLabel": "Tippe LÖSCHEN zur Bestätigung",
  "you.erase.confirmWord": "LÖSCHEN",
  "you.erase.cancel": "Mein Konto behalten",
  "you.erase.confirm": "Mich löschen",
  "you.erase.done": "Deine Löschanfrage ist unterzeichnet und unterwegs. Auf Wiedersehen.",
  // Beacon unterstützen
  // App
  "you.app.title": "APP",
  "you.app.language": "Sprache",
  "you.app.notifications": "Benachrichtigungen",
  "you.app.notificationsOn": "Ein",
  "you.app.notificationsOff": "Aus",
  "you.notif.enabled": "Benachrichtigungen aktiv. Du wirst auch bei geschlossenem Beacon gewarnt.",
  "you.notif.denied": "Benachrichtigungen sind blockiert. Erlaube sie in den Browser-Einstellungen, um bei geschlossenem Beacon gewarnt zu werden.",
  "you.notif.unsupported": "Dieser Browser kann bei geschlossenem Beacon keine Benachrichtigungen anzeigen. In-App-Warnungen funktionieren weiterhin.",
  "you.notif.nopush": "Benachrichtigungen erlaubt, aber der Versand ist auf diesem Server noch nicht eingerichtet. In-App-Warnungen funktionieren weiterhin.",
  "you.notif.subfail": "Benachrichtigungen erlaubt, aber dieses Gerät konnte den Versand nicht aktivieren. In-App-Warnungen funktionieren weiterhin.",
  "you.notif.subfail.noservice": "Benachrichtigungen erlaubt, aber dieses Gerät hat keinen Push-Dienst (z. B. ohne Google Play). In-App-Warnungen funktionieren; Hintergrund-Warnungen brauchen Chrome oder die kommende Beacon-App.",
  "you.notif.dismissed": "Keine Warnungen bei geschlossenem Beacon, bis du Benachrichtigungen erlaubst. Du kannst sie jederzeit aktivieren.",
  "you.app.about": "Über Beacon",
  "you.app.version": "Pilotversion",
  // Markierungen & Einsprüche (nur wenn nicht leer)
  "you.flags.title": "DEINE MARKIERUNGEN & EINSPRÜCHE",
  // E2-Moderation — Markierungsblatt
  "flag.title": "Problem melden",
  "flag.intro": "Meldungen sind privat. Der Autor erfährt nie, wer gemeldet hat.",
  "flag.reason.falseReport": "Falsch oder irreführend",
  "flag.reason.spam": "Spam",
  "flag.reason.harassment": "Belästigung",
  "flag.reason.dangerousAdvice": "Gefährlicher Rat",
  "flag.reason.harvestAttempt": "Versuch, Standorte zu sammeln",
  "flag.reason.doxxing": "Doxxing / persönliche Daten",
  "flag.reason.illegal": "Illegale Inhalte",
  "flag.reason.other": "Etwas anderes",
  "flag.submit": "Meldung senden",
  "flag.done": "Danke — Moderatoren werden sich das ansehen.",
  "flag.error": "Konnte nicht gesendet werden. Bitte erneut versuchen.",
  // E2-Moderation — Du-Transparenzoberfläche
  "you.flags.empty": "Nichts hier. Keine Maßnahmen gegen deine Meldungen.",
  "you.flags.actionLabel": "Maßnahme gegen deine Aktivität",
  "you.flags.weight": "Wird im Ranking niedriger angezeigt",
  "you.flags.reversible": "Dies ist umkehrbar und zeitlich begrenzt. Du kannst Einspruch erheben.",
  "you.flags.appeal": "Einspruch erheben",
  "you.flags.expires": "Läuft ab {date}",
  // E2-Moderation — Einspruchsblatt
  "appeal.title": "Einspruch",
  "appeal.intro": "Erkläre, warum dies rückgängig gemacht werden sollte. Ein Moderator prüft es.",
  "appeal.statement.placeholder": "Warum ist das falsch?",
  "appeal.submit": "Einspruch senden",
  "appeal.done": "Einspruch gesendet. Das Ergebnis siehst du hier.",
  "appeal.error": "Einspruch konnte nicht gesendet werden. Bitte erneut versuchen.",
  // E9-Vorfalldetail — Trend / Aktualität / Quelle / Erweitert (Aufgabe 3)
  "incident.detail.meta.lastConfirmed": "Zuletzt bestätigt",
  "incident.detail.meta.wind": "Wind",
  "incident.detail.meta.trend": "Trend",
  "incident.detail.meta.sources": "Quellen",
  "incident.detail.trend.rising": "Zunehmend",
  "incident.detail.trend.steady": "Stabil",
  "incident.detail.trend.falling": "Nachlassend",
  "incident.detail.worsening": "Verschlimmernd",
  "incident.detail.adv.title": "Erweitert",
  "incident.detail.adv.intensity": "Strahlungsleistung",
  "incident.detail.adv.mw": "{n} MW",
  "incident.detail.adv.peak": "(Spitze {n} MW)",
  "incident.detail.adv.trendAxes": "Trenddetail",
  "incident.detail.adv.weight": "Bestätigungsgewicht",
  "incident.detail.adv.identities": "Bestätigende Behörden",
  "incident.detail.adv.axis.rising": "↑",
  "incident.detail.adv.axis.steady": "→",
  "incident.detail.adv.axis.falling": "↓",
  "incident.detail.wind": "{speed} km/h aus {dir}",
  "compass.n": "N",
  "compass.ne": "NO",
  "compass.e": "O",
  "compass.se": "SO",
  "compass.s": "S",
  "compass.sw": "SW",
  "compass.w": "W",
  "compass.nw": "NW",
  "incident.source.nasa-firms": "NASA FIRMS",
  "incident.source.fogos.pt": "fogos.pt",
  "incident.source.anepc": "ANEPC",
  "now.activity.confirmedAgo": "bestätigt {ago}",
  "now.activity.worsening": "▲ zunehmend",
  // Installationshinweis (M3)
  "you.get.title": "BEACON AUF DEIN SMARTPHONE",
  "you.get.body": "Installiere Beacon, damit Warnungen auch bei geschlossener App ankommen.",
  "you.get.cta": "Beacon holen",
  "install.title": "Beacon auf dem Smartphone installieren",
  "install.desktop.intro": "Beacon warnt dich vor nahegelegenen Gefahren, auch wenn die Seite geschlossen ist.",
  "install.desktop.scan": "Scanne, um Beacon auf dem Smartphone zu öffnen.",
  "install.ios.intro": "Installiere Beacon, damit Warnungen auch bei geschlossener App ankommen.",
  "install.ios.step.share": "Tippe auf die Teilen-Schaltfläche.",
  "install.ios.step.add": "Wähle „Zum Home-Bildschirm“.",
  "install.ios.step.open": "Öffne Beacon vom Home-Bildschirm.",
  "install.ios.note": "Kein App-Store, nichts zum Herunterladen.",
  "install.android.intro": "Installiere Beacon, damit Warnungen auch bei geschlossener App ankommen.",
  "install.android.install": "Beacon installieren",
  "install.android.apk": "Selbst gehostete APK (ohne Google)",
  "install.hint.title": "Beacon installieren",
  "install.hint.body": "Erhalte Warnungen, auch wenn Beacon geschlossen ist.",
  "install.hint.cta": "Installieren",
  "install.hint.dismiss": "Schließen",
  "you.loc.homeTitle": "ZUHAUSE & ORTE",
  "you.loc.alertsTitle": "WARNUNGEN",
  "you.loc.removeConfirm": "Entfernen?",
  "you.loc.cancel": "Abbrechen",
  // Advanced — raw-report layer (power-user opt-in)
  "you.raw.title": "Rohmeldungen (Erweitert)",
  "you.raw.toggle": "Einzelne Meldungen auf der Karte anzeigen",
  "you.raw.warning": "Rohmeldungen haben ein wesentlich höheres Volumen als bestätigte Vorfälle und verbrauchen mehr Daten und Akku. Trotzdem aktivieren?",
  "you.raw.depth.label": "Wie weit zurück laden",
  "you.raw.depth.off": "Nur live",
  "you.raw.depth.shallow": "Wenig",
  "you.raw.depth.medium": "Mittel",
  "you.raw.depth.deep": "Tief",
  // Advanced — spread-cone debug cells (authoritative H3 overlay)
  "you.cone.title": "Kegelzellen (erweitert)",
  "you.cone.toggle": "Die genauen Zellen der Alarm-Engine anzeigen",
  "you.cone.helper": "Überlagert die maßgeblichen H3-Zellen, mit denen die Alarm-Engine entscheidet, wer im Pfad einer Gefahr liegt – nützlich, um zu prüfen, warum ein Alarm ankam oder nicht.",

  "commons.card.title": "Das Gemeingut",
  "commons.card.thisPeriod": "Dieser Zeitraum",
  "commons.card.runRate": "Laufende Kosten gegenüber Beiträgen",
  "commons.card.cumulative": "Gesamt",
  "commons.card.oneTime": "Einmalig (z. B. Entwicklung)",
  "commons.card.yourCost": "Dein fairer Anteil bisher",
  "commons.card.yourGiven": "Du hast beigetragen",
  "commons.card.operatorStated": "vom Betreiber angegeben",
  "commons.card.chipIn": "Beitragen",
  "commons.card.chippedIn": "Du hast diesen Monat beigetragen — danke.",
  "commons.card.need": "Beacon hat diesen Monat {amount} gebraucht, um dich zu warnen.",
  "commons.card.viewTransparency": "Transparenz ansehen",
  "commons.card.deficit": "Defizit",
  "commons.card.surplus": "Überschuss",
  "commons.card.empty": "Noch keine Aktivität im Gemeingut.",
  "commons.chipIn.title": "Zum Gemeingut beitragen",
  "commons.chipIn.pickToken": "Wähle, was du senden möchtest",
  "commons.chipIn.amount": "Betrag (optional)",
  "commons.chipIn.getAddress": "Adresse abrufen",
  "commons.chipIn.address": "An diese Adresse senden",
  "commons.chipIn.copy": "Adresse kopieren",
  "commons.chipIn.copied": "Kopiert",
  "commons.chipIn.deadline": "Zahle innerhalb von {min} Min., um gutgeschrieben zu werden. Spätere Zahlungen helfen dem Gemeingut weiterhin, erscheinen aber nicht auf deiner Karte.",
  "commons.chipIn.oneClick": "Mit verbundener Wallet zahlen",
  "commons.chipIn.noWallet": "Keine Browser-Wallet erkannt – scanne oder füge die Adresse ein.",
  "commons.chipIn.sent": "Transaktion gesendet",
  "commons.chipIn.error": "Adresse konnte nicht abgerufen werden. Versuche es erneut.",
  "commons.chipIn.intro": "Ein einmaliger Beitrag zu den Betriebskosten dieser Instanz — on-chain, ohne Anmeldung.",
  "commons.chipIn.network": "Auf {network} senden",
  "commons.chipIn.wrongChain": "Nur in diesem Netzwerk senden — Guthaben auf einer anderen Chain kann nicht erkannt werden.",
  "commons.chipIn.afterTitle": "Nach dem Senden",
  "commons.chipIn.afterDetect": "Deine Einzahlung wird automatisch on-chain erkannt — du musst nichts weiter tun.",
  "commons.chipIn.afterAppear": "Sobald das Netzwerk bestätigt (meist ein bis zwei Minuten), erscheint sie in den Commons-Summen und auf deiner Karte, wenn du innerhalb des Zeitfensters gezahlt hast.",
  "commons.chipIn.done": "Fertig",
  "commons.chipIn.close": "Schließen",
  "commons.received": "Beitrag erhalten — danke!",
  "commons.chipIn.waiting": "Warte auf deine Einzahlung in der Chain…",
  "commons.chipIn.receivedTitle": "Beitrag erhalten",
  "commons.chipIn.receivedBody": "Danke für deinen Beitrag — er steht jetzt im Commons-Ledger.",
  "commons.privacy.hidden": "Vor allen verborgen",
  "commons.privacy.public": "Öffentlich verborgen, kurz von dieser Instanz gesehen",
  "commons.privacy.custodial": "Deine Bank/dein Anbieter sieht dies",
  "commons.transparency.title": "Gemeingut-Transparenz",
  "commons.transparency.intro": "Vollständig aus signierten Ereignissen im Firehose berechnet. Jeder kann dies unabhängig nachvollziehen.",
  "commons.transparency.series": "Laufende Kosten gegenüber Beiträgen, je Zeitraum",
  "commons.transparency.oneTimeSeries": "Einmalige Kosten, je Zeitraum",
  "commons.transparency.projection": "Dieser Zeitraum (Schätzung, anteilig)",
  "commons.transparency.history": "Verlauf bis zum Ursprung",
  "commons.transparency.basis": "Grundlage des Nenners",
  "commons.transparency.reproduce": "Reproduziere dies aus dem Firehose: jede Eingabe ist ein signiertes Kosten- oder Beitragsereignis.",
  "commons.transparency.colCost": "Laufende Kosten",
  "commons.transparency.colContrib": "Beiträge",
  "commons.transparency.colNet": "Netto",
  "commons.transparency.colOneTime": "Einmalig",
  "commons.transparency.estimate": "Schätzung",
};
